function ReportScheduleFilter() {
    "use strict";

    this.__type = 'ReportScheduleFilter:www.veritracks.com';
    this.Id = -1;
    this.ReportScheduleId = -1;
    this.ReportFilterId = -1;
    this.ReportFilterValue = '';
    this.ReportFilterText = '';
    this.ReportFilterName = '';
    this.ReportFilterLabel = '';
    this.OverrideFlag = 0;
    this.RequiredFlag = 0;
    this.ReportFilterSortId = -1;
    this.IsActive = true;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
}
if (typeof exports !== 'undefined') {
    module.exports = ReportScheduleFilter;
}